import { render, staticRenderFns } from "./BuildingIcon.vue?vue&type=template&id=0c2d1d69"
import script from "./BuildingIcon.vue?vue&type=script&lang=js"
export * from "./BuildingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports